// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"23ece6e7","206":"31d6cfe0","399":"31d6cfe0","494":"23ece6e7","531":"31d6cfe0","570":"23ece6e7","597":"23ece6e7","915":"31d6cfe0"}[chunkId] + ".chunk.css";
};